import { Form } from 'react-bootstrap';

const ToggleSwitch = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  id,
}) => {
  const handleChange = (e) => {
    onChange({ name: e.target.name, value: !value });
  };
  return (
    <div className={className}>
      {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <div>
        <div className="d-flex align-items-center">
          <Form.Check
            name={name}
            type="switch"
            id={id || 'custom-switch'}
            checked={value}
            className={inputClassName}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
